import { ApiError } from '../../api/types';
import { UserContactViewModel } from '../../model/profile/types';

export const REGISTER_UNIFIED_USER_STARTED = 'REGISTER_UNIFIED_USER_STARTED';
export const REGISTER_UNIFIED_USER_SUCCEEDED = 'REGISTER_UNIFIED_USER_SUCCEEDED';
export const REGISTER_UNIFIED_USER_FAILED = 'REGISTER_UNIFIED_USER_FAILED';
export const LOAD_UNIFIED_USERPROFILE_STARTED = 'LOAD_UNIFIED_USERPROFILE_STARTED';
export const LOAD_UNIFIED_USERPROFILE_SUCCEEDED = 'LOAD_UNIFIED_USERPROFILE_SUCCEEDED';
export const LOAD_UNIFIED_USERPROFILE_FAILED = 'LOAD_UNIFIED_USERPROFILE_FAILED';
export const VERIFY_UNIFIED_USER_STARTED = 'VERIFY_UNIFIED_USER_STARTED';
export const VERIFY_UNIFIED_USER_FAILED = 'VERIFY_UNIFIED_USER_FAILED';
export const VERIFY_UNIFIED_USER_SUCCEEDED = 'VERIFY_UNIFIED_USER_SUCCEEDED';
export const RETRIEVE_DECRYPTED_PROFILE_ID_STARTED = 'RETRIEVE_DECRYPTED_PROFILE_ID_STARTED';
export const RETRIEVE_DECRYPTED_PROFILE_ID_FAILED = 'RETRIEVE_DECRYPTED_PROFILE_ID_FAILED';
export const RETRIEVE_DECRYPTED_PROFILE_ID_SUCCEEDED = 'RETRIEVE_DECRYPTED_PROFILE_ID_SUCCEEDED';
export const RETRIEVE_ENCRYPTED_PROFILE_ID_STARTED = 'RETRIEVE_ENCRYPTED_PROFILE_ID_STARTED';
export const RETRIEVE_ENCRYPTED_PROFILE_ID_FAILED = 'RETRIEVE_ENCRYPTED_PROFILE_ID_FAILED';
export const RETRIEVE_ENCRYPTED_PROFILE_ID_SUCCEEDED = 'RETRIEVE_ENCRYPTED_PROFILE_ID_SUCCEEDED';

export interface VerifyUserViewModel {
    verificationData: NewUnifiedUserVerificationModel;
    verifyUserResult: VerifyUserResult;
}

export interface UnifiedRegistrationModel {
    error: string;
    profileId: string;
    userProfileExists: boolean;
    userProfileSavedResult: RegisterUserResult;
    userProfileData: UserViewModel;
    verifyUserData: VerifyUserViewModel;
    loading: boolean;
}

export interface UserViewModel {
    email: string;
    firstName: string;
    lastName: string;
    title: string;
    organizationname: string;
    department: string;
    address: string;
    city: string;
    stateorProvince: string;
    country: string;
    postalCode: string;
    phone: string;
    addressType?: number;
    sourceUrl: string;
    error?: ApiError;
    crmGuid: string;
    activated: boolean;
}

export interface NewUnifiedUserVerificationModel {
    password: string;
    profileId: string;
    error?: ApiError;
}

export interface UserProfile {
    subscriptions: string[];
    userName: string;
    email: string;
}

export interface VerifyUserResult {
    userProfile: UserProfile;
    message: string;
    success: boolean;
}

export interface VerifyUserStartedAction {
    type: typeof VERIFY_UNIFIED_USER_STARTED;
    payload: string;
}

export interface VerifyUserSucceededAction {
    type: typeof VERIFY_UNIFIED_USER_SUCCEEDED;
    payload: VerifyUserViewModel;
}

export interface VerifyUserFailedAction {
    type: typeof VERIFY_UNIFIED_USER_FAILED;
    payload: string;
}

export interface LoadUserProfileAction {
    type: typeof LOAD_UNIFIED_USERPROFILE_STARTED;
    payload: string[];
}
export interface LoadUserProfileFailedAction {
    type: typeof LOAD_UNIFIED_USERPROFILE_FAILED;
    payload: string;
}
export interface LoadUserProfileSucceededAction {
    type: typeof LOAD_UNIFIED_USERPROFILE_SUCCEEDED;
    payload: UserContactViewModel;
}

export interface RegisterUserStartedAction {
    type: typeof REGISTER_UNIFIED_USER_STARTED;
    payload: string;
}

export interface RegisterUserSucceededAction {
    type: typeof REGISTER_UNIFIED_USER_SUCCEEDED;
    payload: string;
}

export interface RegisterUserFailedAction {
    type: typeof REGISTER_UNIFIED_USER_FAILED;
    payload: string;
}
export interface RegisterUserResult {
    message: string;
    success: boolean;
}

export interface RetrieveDecryptedProfileIdStartedAction {
    type: typeof RETRIEVE_DECRYPTED_PROFILE_ID_STARTED;
    payload: string;
}

export interface RetrieveDecryptedProfileIdSucceededAction {
    type: typeof RETRIEVE_DECRYPTED_PROFILE_ID_SUCCEEDED;
    payload: string;
}

export interface RetrieveDecryptedProfileIdFailedAction {
    type: typeof RETRIEVE_DECRYPTED_PROFILE_ID_FAILED;
    payload: string;
}

export interface RetrieveEncryptedProfileIdStartedAction {
    type: typeof RETRIEVE_ENCRYPTED_PROFILE_ID_STARTED;
    payload: string;
}

export interface RetrieveEncryptedProfileIdSucceededAction {
    type: typeof RETRIEVE_ENCRYPTED_PROFILE_ID_SUCCEEDED;
    payload: string;
}

export interface RetrieveEncryptedProfileIdFailedAction {
    type: typeof RETRIEVE_ENCRYPTED_PROFILE_ID_FAILED;
    payload: string;
}

export type UnifiedRegistrationActionTypes =
    | RegisterUserStartedAction
    | RegisterUserSucceededAction
    | RegisterUserFailedAction
    | LoadUserProfileAction
    | LoadUserProfileFailedAction
    | LoadUserProfileSucceededAction
    | VerifyUserStartedAction
    | VerifyUserSucceededAction
    | VerifyUserFailedAction
    | RetrieveDecryptedProfileIdStartedAction
    | RetrieveDecryptedProfileIdSucceededAction
    | RetrieveDecryptedProfileIdFailedAction
    | RetrieveEncryptedProfileIdStartedAction
    | RetrieveEncryptedProfileIdSucceededAction
    | RetrieveEncryptedProfileIdFailedAction